import { render, staticRenderFns } from "./k-nav-main.vue?vue&type=template&id=4e27b9e5&lang=pug&"
import script from "./k-nav-main.vue?vue&type=script&lang=js&"
export * from "./k-nav-main.vue?vue&type=script&lang=js&"
import style0 from "./k-nav-main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e27b9e5')) {
      api.createRecord('4e27b9e5', component.options)
    } else {
      api.reload('4e27b9e5', component.options)
    }
    module.hot.accept("./k-nav-main.vue?vue&type=template&id=4e27b9e5&lang=pug&", function () {
      api.rerender('4e27b9e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-nav-main.vue"
export default component.exports